;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .controller('ModalRuleSeverityUpdateInstanceCtrl', [
      '$scope',
      '$uibModalInstance',
      'newSeverity',
      'affectedVulns',
      'exceptionVulns',
      'ruleId',
      ModalRuleSeverityUpdateInstanceCtrl
    ])

  function ModalRuleSeverityUpdateInstanceCtrl(
    $scope,
    $uibModalInstance,
    newSeverity,
    affectedVulns,
    exceptionVulns,
    ruleId
  ) {
    $scope.model = {
      new_severity: newSeverity,
      vulnerabilities_affected: affectedVulns,
      vulnerabilities_exceptions: exceptionVulns,
      rule: ruleId
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.override = function () {
      $uibModalInstance.close({ override: true })
    }

    $scope.keep = function () {
      $uibModalInstance.close({ override: false })
    }
  }
})()
